import { ClassName, GADataType, I18nText } from '../../../../../types';
import { IconsEnum } from '../../../../../assets/icons/types';
import { SelectedLifestyleUUID } from '../../../selectedLifestylesTypes';

import {
  FETCH_SELECTED_LIFESTYLE_DOWNLOAD_URLS_QUERY,
  FetchSelectedLifestyleDownloadUrlsQueryResponse
} from '../../../queries/fetchSelectedLifestyleDownloadUrls.query';

import { useSelectedLifestyle } from '../../../../selectedLifestyles/hooks/useSelectedLifestyle';
import { useShowToastOnErrorChange } from '../../../../../common/hooks/useShowToastOnErrorChange';

import { DownloadUrlsModalButton } from '../../../../common/components/modalButtons/DownloadUrlsModalButton';

import { SelectedLifestyleCache } from '../../../SelectedLifestyleCache';

import { TooltipPlacement } from '../../../../../helpers/tooltips/tooltipsConstants';

interface DownloadSelectedLifestyleSeparatelyButtonProps {
  className?: ClassName;
  i18nText?: I18nText;
  icon?: IconsEnum;
  iconClassName?: ClassName;
  selectedLifestyleUuid: SelectedLifestyleUUID;
  tooltipI18nText?: I18nText;
  tooltipPlacement?: TooltipPlacement;
  tooltipSingleton?: boolean;
}

function DownloadSelectedLifestyleSeparatelyButton({
  className,
  dataGa,
  i18nText,
  icon,
  iconClassName,
  selectedLifestyleUuid,
  tooltipI18nText,
  tooltipPlacement,
  tooltipSingleton
}: DownloadSelectedLifestyleSeparatelyButtonProps & GADataType) {
  const {
    selectedLifestyleLoading,
    refetchSelectedLifestyle,
    selectedLifestyleError
  } = useSelectedLifestyle<FetchSelectedLifestyleDownloadUrlsQueryResponse>({
    cacheKey: SelectedLifestyleCache.downloadUrls(selectedLifestyleUuid),
    options: {
      enabled: false,
      enabledPlaceholder: false
    },
    query: FETCH_SELECTED_LIFESTYLE_DOWNLOAD_URLS_QUERY,
    uuid: selectedLifestyleUuid
  });

  useShowToastOnErrorChange({ error: selectedLifestyleError });

  return (
    <DownloadUrlsModalButton<'selectedLifestyle'>
      className={className}
      dataGa={dataGa}
      disabled={selectedLifestyleLoading}
      downloadUrlsScope="downloadUrls"
      i18nText={i18nText}
      icon={icon}
      iconClassName={iconClassName}
      refetchItemDownloadUrls={refetchSelectedLifestyle}
      scope="selectedLifestyle"
      tooltipI18nText={tooltipI18nText}
      tooltipPlacement={tooltipPlacement}
      tooltipSingleton={tooltipSingleton}
    />
  );
}

export default DownloadSelectedLifestyleSeparatelyButton;
